import React, { useEffect, useState } from "react";
import Header from "../../../../Componets/Header";
import Table from "../../../../Componets/Table";
import toast from "react-hot-toast";
import tables from "../../../../Data/Tables/Suppliers/Statement/tables";
import headers from "../../../../Data/Tables/Suppliers/Statement/headers";
import Loadercomponent from "../../../../Componets/Loader";
import { useParams } from "react-router-dom";
import { get_all_purchases } from "../../../../Controllers/Purchases/Orders";
import DateTimeBadge from "../../../../Componets/DateTime/DateTimeBadge";
import UserCurrency from "../../../../Componets/UserCurrency";
import jsPDF from "jspdf";
import { Button } from "antd";
import { registerCairoFont } from "../../../Reports/cairo-font";
import autoTable from "jspdf-autotable";
import { get_user_auth } from "../../../../Controllers/Layouts/Layouts";

const SupplierOutstandingStatement = () => {
  const [loader, setLoader] = useState(false);
  const [header, setHeader] = useState(headers);
  const [body, setBody] = useState([]);
  const [summary, setSummary] = useState({
    totalOutstanding: 0,
    totalPurchases: 0,
    totalAmount: 0,
    overdueAmount: 0,
  });
  const [supplierName, setSupplierName] = useState("");
  const [authorizeMail, setAuthorizeMail] = useState(false);

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
  });

  const { id } = useParams();
  localStorage.setItem("Supplier_Id", id);

  const paginationdata = (data) => {
    let headerdata = {};
    header?.components?.map((value) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      supplier: headerdata?.supplier,
      status: headerdata?.status,
      date: headerdata?.date,
    });
  };

  const formdata = (data) => {
    let page = data?.search ? pagination?.currentPage : 1;
    fetchData({
      ...data,
      currentPage: page,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const calculateTotalPaid = (purchase) => {
    if (!purchase?.payments || !Array.isArray(purchase?.payments)) return 0;
    return purchase.payments.reduce(
      (sum, payment) => sum + (payment.amount || 0),
      0,
    );
  };

  const calculateOutstanding = (purchase) => {
    const total = purchase?.total || 0;
    const paid = calculateTotalPaid(purchase);
    return total - paid;
  };

  const isOverdue = (purchase) => {
    if (!purchase?.due_date) return false;
    return new Date(purchase.due_date) < new Date();
  };

  const fetchSummary = async () => {
    try {
      const params = {
        supplier: id,
        source: "Supplier-Outstanding-Statement",
      };

      const response = await get_all_purchases(params);

      console.log("Summary Response:", response);

      if (response?.status) {
        const purchases = response?.data?.data || [];
        let totalOutstanding = 0;
        let overdueAmount = 0;
        let totalAmount = 0;

        purchases.forEach((purchase) => {
          setSupplierName(purchase.supplier?.name || "N/A");
          const outstanding = calculateOutstanding(purchase);
          totalOutstanding += outstanding;
          totalAmount += purchase?.total || 0;

          if (purchase.due_date && outstanding > 0) {
            if (new Date(purchase.due_date) < new Date()) {
              overdueAmount += outstanding;
            }
          }
        });

        setSummary({
          totalOutstanding,
          totalPurchases: response?.data?.totalCount || purchases.length,
          overdueAmount,
          totalAmount,
        });
      } else {
        toast.error("Failed to fetch summary");
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const params = {
        search: tabledata?.search,
        supplier: tabledata?.supplier || id,
        status: tabledata?.status,
        date: tabledata?.date,
        page: tabledata?.currentPage || 1,
        limit: 10,
        source: "Supplier-Outstanding-Statement",
      };

      const purchasesResponse = await get_all_purchases(params);

      if (purchasesResponse?.status) {
        let purchases = purchasesResponse?.data?.data || [];

        purchases = purchases.filter(
          (purchase) => calculateOutstanding(purchase) > 0,
        );

        const startIndex = ((params.page || 1) - 1) * params.limit;
        const paginatedPurchases = purchases.slice(
          startIndex,
          startIndex + params.limit,
        );

        const tableData = paginatedPurchases.map((purchase) => {
          const outstanding = calculateOutstanding(purchase);
          const paidAmount = calculateTotalPaid(purchase);
          const overdue = isOverdue(purchase);

          return {
            path: `/app/purchases/orders/view/${purchase?._id}`,
            "PO Number": `#PO-${purchase.number}`,
            Supplier: purchase.supplier?.name || "N/A",
            Date: <DateTimeBadge date={purchase?.date} />,
            "Due Date": purchase.due_date ? (
              <DateTimeBadge date={purchase?.due_date} />
            ) : (
              "-"
            ),
            "Total Amount": (
              <>
                <UserCurrency /> {(purchase.total || 0).toFixed(3)}
              </>
            ),
            "Paid Amount": (
              <>
                <UserCurrency /> {paidAmount.toFixed(3)}
              </>
            ),
            Outstanding: (
              <>
                <UserCurrency /> {outstanding.toFixed(3)}
              </>
            ),
            "Payment Status":
              purchase?.payment_status == 2 ? (
                <span className="bg-green-100 text-green-600 text-sm px-2 py-1 rounded-lg">
                  Paid
                </span>
              ) : purchase?.payment_status == 1 ? (
                <span className="bg-yellow-100 text-yellow-600 text-sm px-2 py-1 rounded-lg">
                  Partial
                </span>
              ) : (
                <span className="bg-red-100 text-red-600 text-sm px-2 py-1 rounded-lg">
                  Unpaid
                </span>
              ),
            "Delivery Status":
              purchase?.delivery_status == 2 ? (
                <span className="bg-green-100 text-green-600 text-sm px-2 py-1 rounded-lg">
                  Delivered
                </span>
              ) : purchase?.delivery_status == 1 ? (
                <span className="bg-yellow-100 text-yellow-600 text-sm px-2 py-1 rounded-lg">
                  Partial
                </span>
              ) : (
                <span className="bg-red-100 text-red-600 text-sm px-2 py-1 rounded-lg">
                  Pending
                </span>
              ),
          };
        });

        setBody(tableData);

        setPagination({
          currentPage: params.page || 1,
          totalCount: purchases.length,
          totalPages: Math.ceil(purchases.length / params.limit),
        });
      } else {
        toast.error("Failed to fetch invoices");
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoader(false);
    }
  };

  const headerReset = () => {
    let componentData = [];
    headers?.components?.map((value) => {
      componentData?.push({
        ...value,
        value: null,
      });
    });
    setHeader({ ...headers, components: componentData });
  };

  const fetchAllPurchases = async () => {
    try {
      const headerdata = {};
      header?.components?.forEach((value) => {
        headerdata[value.name] = value.value;
      });

      const params = {
        supplier: id,
        search: headerdata?.search,
        status: headerdata?.status,
        date: headerdata?.date,
        source: "Supplier-Outstanding-Statement",
      };

      const response = await get_all_purchases(params);

      if (response?.status) {
        return (response?.data?.data || []).filter(
          (p) => calculateOutstanding(p) > 0,
        );
      }

      return [];
    } catch (error) {
      toast.error("Failed to fetch purchases");
      return [];
    }
  };

  const downloadCSV = async () => {
    try {
      const purchases = await fetchAllPurchases();

      if (!purchases.length) {
        toast.error("No data available");
        return;
      }

      const headers = [
        "S.No",
        "PO Number",
        "Supplier",
        "Date",
        "Due Date",
        "Total",
        "Paid",
        "Outstanding",
        "Payment Status",
        "Delivery Status",
      ];

      const rows = purchases.map((p, index) => {
        const paid = calculateTotalPaid(p);
        const outstanding = calculateOutstanding(p);

        return [
          index + 1,
          p.number,
          p.supplier?.name || "",
          p.date ? new Date(p.date).toLocaleDateString("en-GB") : "",
          p.due_date ? new Date(p.due_date).toLocaleDateString("en-GB") : "",
          (p.total || 0).toFixed(3),
          paid.toFixed(3),
          outstanding.toFixed(3),
          p.payment_status === 2
            ? "Paid"
            : p.payment_status === 1
              ? "Partial"
              : "Unpaid",
          p.delivery_status === 2
            ? "Delivered"
            : p.delivery_status === 1
              ? "Partial"
              : "Pending",
        ].join(",");
      });

      const csv = [headers.join(","), ...rows].join("\n");

      const blob = new Blob(["\uFEFF" + csv], {
        type: "text/csv;charset=utf-8;",
      });

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `Supplier_Statement_${new Date()
        .toLocaleDateString()
        .replace(/\//g, "_")}.csv`;

      link.click();
    } catch (err) {
      toast.error("CSV download failed");
    }
  };

  const downloadPDF = async () => {
    try {
      const purchases = await fetchAllPurchases();

      if (!purchases.length) {
        toast.error("No data available");
        return;
      }

      const doc = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a4",
      });

      registerCairoFont(doc);

      const pageWidth = doc.internal.pageSize.getWidth();

      doc.setFont("Cairo-Bold", "bold");

      doc.setFontSize(18);
      doc.text(
        `Supplier Outstanding Report - ${supplierName}`,
        pageWidth / 2,
        18,
        { align: "center" },
      );

      const now = new Date();
      const formattedDate = now.toLocaleDateString("en-GB");
      const formattedTime = now.toLocaleTimeString();
      doc.setFontSize(10);
      doc.text(
        `Downloaded on: ${formattedDate} ${formattedTime}`,
        pageWidth / 2,
        26,
        { align: "center" },
      );

      const rows = purchases.map((p, index) => {
        const paid = calculateTotalPaid(p);
        const outstanding = calculateOutstanding(p);

        return [
          index + 1,
          p.number,
          p.date ? new Date(p.date).toLocaleDateString("en-GB") : "-",
          p.due_date ? new Date(p.due_date).toLocaleDateString("en-GB") : "-",
          (p.total || 0).toFixed(3),
          paid.toFixed(3),
          outstanding.toFixed(3),
          p.payment_status === 2
            ? "Paid"
            : p.payment_status === 1
              ? "Partial"
              : "Unpaid",
          p.delivery_status === 2
            ? "Delivered"
            : p.delivery_status === 1
              ? "Partial"
              : "Pending",
        ];
      });

      autoTable(doc, {
        startY: 32,
        head: [
          [
            "S.No",
            "PO Number",
            "Date",
            "Due Date",
            "Total",
            "Paid",
            "Outstanding",
            "Payment",
            "Delivery",
          ],
        ],
        body: rows,
        styles: {
          font: "Cairo",
          textColor: [0, 0, 0],
          lineColor: [222, 222, 222],
          fillColor: false,
          lineWidth: 0.2,
        },
        headStyles: {
          font: "Cairo",
          fontStyle: "bold",
          fillColor: false,
          lineColor: [222, 222, 222],
          lineWidth: 0.2,
        },
        alternateRowStyles: {
          fillColor: false,
        },
      });

      doc.save("Supplier_Statement.pdf");
    } catch (err) {
      toast.error("PDF download failed");
    }
  };

  const fetchAuthorizeUser = async () => {
    try {
      const response = await get_user_auth();
      if (response?.status) {
        const authorize_email =
          response?.data?.branch?.plan === 3000 &&
          response?.data?.email?.trim().toLowerCase() ===
            process.env.REACT_APP_CROWN_PHARMACY_EMAIL?.trim().toLowerCase();

        setAuthorizeMail(authorize_email);
        setLoader(false);
      } else {
        toast?.error(response?.message || "Failed to fetch User Auth");
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  useEffect(() => {
    if (id) {
      fetchData();
      fetchSummary();
    }
    headerReset();
  }, [id]);

  useEffect(() => {
    fetchAuthorizeUser();
  }, []);

  return (
    <div>
      <Header headers={header} setHeaders={setHeader} formdata={formdata}>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-4">
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h3 className=" text-gray-700 mb-2">Total Outstanding</h3>
            <p className=" text-red-600">
              <UserCurrency /> {summary.totalOutstanding.toFixed(3)}
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h3 className=" text-gray-700 mb-2">Total Purchases</h3>
            <p className=" text-green-600">{summary.totalPurchases}</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h3 className=" text-gray-700 mb-2">Total Amount</h3>
            <p className=" text-green-600">
              <UserCurrency /> {summary.totalAmount.toFixed(3)}
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h3 className=" text-gray-700 mb-2">Overdue Amount</h3>
            <p className=" text-orange-600">
              <UserCurrency /> {summary.overdueAmount.toFixed(3)}
            </p>
          </div>
        </div>

        {authorizeMail && (
          <div className="flex gap-3 justify-end mt-4">
            <Button type="primary" onClick={downloadCSV}>
              Download CSV
            </Button>

            <Button type="primary" onClick={downloadPDF}>
              Download PDF
            </Button>
          </div>
        )}

        <Loadercomponent loader={loader}>
          <Table
            head={tables}
            body={body}
            pagination={pagination}
            paginationdata={paginationdata}
            summary={2}
          />
        </Loadercomponent>
      </Header>
    </div>
  );
};

export default SupplierOutstandingStatement;
